/**
 *  Initialize jsModule
 */
var _moduleContent = (function () {

  const readMoreList = jQuery('.module__read-more');

  if (readMoreList.length > 0) {
    readMoreList.on('click', function() {
      jQuery(this).next('.module__field-content').toggleClass('module__field-content--hidden');
      jQuery('span', this).toggle();
    });
  }

  var pub = {}; // public facing functions

  pub.init = function () {

  };

  return pub;

}());
